<template>
  <v-select
    label="Business Model"
    item-text="label"
    item-value="code"
    v-model="selected"
    :items="items"
    @change="onChange"
    :outlined="outlined"
    :hide-details="hideDetails"
    :disabled="disabled"
  ></v-select>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../helpers";
export const query = gql`
  query businessModels {
    businessModels {
      edges {
        node {
          id
          name
          code
        }
      }
    }
  }
`;
export default {
  name: "business-model-list-select",

  props: {
    value: {
      type: String,
      default: () => "BM1",
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selected: this.value ? this.value : "BM1",
    };
  },
  computed: {
    items() {
      return this.businessModels && this.businessModels.edges.length > 0
        ? this.businessModels.edges
            .map(removeGQLTypename)
            .map((item) => ({ ...item, label: `${item.code} - ${item.name}` }))
        : [];
    },
  },
  methods: {
    onChange(event) {
      if (event) {
        this.$emit("input", event);
      }
    },
  },
  watch: {
    value(newVal) {
      this.selected = newVal;
    },
  },
  apollo: {
    businessModels: {
      query,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/BusinessModelListSelect.vue